import { useNavigate } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Verdict } from "@/components/Bits";
import { fmtDate, fmtDur } from "@/lib/api";

export default function SessionTable({ sessions, showUser, basePath = "/sessions" }) {
  const navigate = useNavigate();
  if (!sessions.length) return <p className="text-slate-500 p-8 border border-slate-800" data-testid="sessions-empty">No assessments yet.</p>;
  return (
    <div className="border border-slate-800 overflow-x-auto">
      <Table data-testid="sessions-table">
        <TableHeader>
          <TableRow className="border-slate-800 hover:bg-transparent">
            <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">Started</TableHead>
            {showUser && <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">Traveller</TableHead>}
            <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">Team</TableHead>
            <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">Destination</TableHead>
            <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">Duration</TableHead>
            {showUser && <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">Score</TableHead>}
            <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">{showUser ? "Result" : "Status"}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sessions.map((s) => (
            <TableRow key={s.id} data-testid={`session-row-${s.id}`} className="border-slate-800 cursor-pointer hover:bg-slate-900"
              onClick={() => navigate(s.status === "in_progress" && !showUser ? `/interview/${s.id}` : `${basePath}/${s.id}`)}>
              <TableCell className="font-mono text-xs text-slate-400">{fmtDate(s.started_at)}</TableCell>
              {showUser && <TableCell><div className="text-white text-sm">{s.user_name}</div><div className="font-mono text-[11px] text-slate-500">{s.user_email}</div></TableCell>}
              <TableCell className="text-sm text-slate-300">{s.team_role_label}</TableCell>
              <TableCell className="text-sm text-slate-300">{s.destination}</TableCell>
              <TableCell className="font-mono text-xs text-slate-400">{s.status === "in_progress" ? "-" : fmtDur(s.duration_seconds)}</TableCell>
              {showUser && <TableCell className="font-cabinet font-bold text-white text-lg">{s.score ?? "-"}</TableCell>}
              <TableCell><Verdict session={s} testid={`session-verdict-${s.id}`} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
